import { Component, OnDestroy } from '@angular/core';
import { DirectAddService } from '@app/modules/direct/services/direct-add.service';

@Component({
  standalone: false,
  templateUrl: './direct-add.component.html',
  styleUrls: ['./direct-add.component.scss'],
})
export class DirectAddComponent implements OnDestroy {
  constructor(public directAddService: DirectAddService) {}

  ngOnDestroy(): void {
    this.directAddService.clean();
  }
}
